module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_01-8df85c559479ab736c822c7bd64b7166.webp";